export default __webpack_public_path__ + "media/images/not-found-1dab26b7df4f8a27bafee93a3506fde1.png";